/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import Removeimageindicator from 'material/embeds/removeimageindicator/removeimageindicator';
import Background from 'material/embeds/content/shared/background/background_container';
import PartnerLogo from 'material/embeds/content/shared/logo/partner/partner_container';
import Question from 'material/embeds/content/shared/question/question_container';
import AnswerSet from 'material/embeds/content/shared/answerset/answerset_container';
import AddAnswer from 'material/embeds/content/edit/addanswer/addanswer_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/content/contenttype/poll/poll_styles';



/* ========== ~~~~~~~~~~ EMBED : CONTENT : POLL ~~~~~~~~~~ ========== */
class Poll extends Component {
    handleImageRemoval = () => {
        this.props.removeBackgroundImage(this.props.contentId)
    };
    render() {
        return(
            <div className={`uniquecontent poll ${this.props.classes.poll}`}>
                <div className={`structure header`}>
                    <div className={`structureinner`}>
                        <PartnerLogo />
                    </div>
                </div>
                <div className={`structure body`}>
                    <div className={`structureinner`}>
                        <Question contentId={this.props.contentId} isEditable={this.props.isEditable} />
                        <AnswerSet contentId={this.props.contentId} isEditable={this.props.isEditable} />
                    </div>
                </div>
                <Background
                    isSelected={this.props.isSelected}
                    backgroundImageURL={this.props.backgroundImageURL}
                    currentBackgroundImage={this.props.currentBackgroundImage}
                    previewBackgroundImageURL={this.props.previewBackgroundImageURL}
                    backgroundColor={this.props.backgroundColor}
                    contentId={this.props.contentId}
                    isEditable={this.props.isEditable} />
                {this.props.isEditable && <Removeimageindicator handleRemoval={this.handleImageRemoval}/>}
                <AddAnswer contentId={this.props.contentId} />
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Poll);
